import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

interface ShipmentContentsQuestionBubbleProps {
  handlingUnitType: string | undefined;
  usePlural: boolean;
  preposition: string;
}

const LineItemsShipmentContentsQuestionBubble: React.FC<
  ShipmentContentsQuestionBubbleProps
> = (props: ShipmentContentsQuestionBubbleProps) => {
  const handlingUnitType = props.handlingUnitType
    ? props.handlingUnitType.toLowerCase()
    : undefined;
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">{`${props.handlingUnitType || "Shipment"} Content`}</T>
          {props.handlingUnitType ? (
            <T size="xs" color="secondary">
              {`Enter an accurate description of what is ${props.preposition} each ${handlingUnitType}.`}
            </T>
          ) : (
            <T size="xs" color="secondary">
              Enter a description of what you are shipping, and the number of
              pieces that make up the shipment.
            </T>
          )}
          <T size="xs" color="secondary">
            A vague description can cause delays if your shipment is crossing
            the border.
          </T>
          <T size="xs" color="secondary">
            Each carrier maintains their own list of prohibited items. If you
            have any doubt if something is suitable to ship please contact us,
            and we can advise.
          </T>
          <Link
            href="https://help.freightsimple.com/using-freightsimple/quoting/shipment-contents#description"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default LineItemsShipmentContentsQuestionBubble;
